function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { store } from '../../index.js';
import { sendUnityMessage, respondToUnity, sendUnityMessageAsync } from '../../shared/unity_comms';
import { predict, reloadAllExamples } from '../../shared/image_classifier';
import { addInference, displayInferences } from '../../redux/actions/inferences';
import { setUnityConveyorWaitingForScore, setUnityConveyorBeltAwake } from '../../redux/actions/unity.js';
import { batchScore, hiddenInferences } from '../../redux/reducers/inferences';
import { addScore } from '../../redux/actions/scores';
export var registerEvents = function registerEvents() {
  respondToUnity(unity(), function (request) {
    var serializedRequest = JSON.parse(request);
    var callback = events[serializedRequest.topic];

    if (callback) {
      callback(serializedRequest);
    }
  });
};
export var requestInferenceBatch = function requestInferenceBatch() {
  store.dispatch(setUnityConveyorWaitingForScore(true));
  console.log("Requesting Inferences");
  sendUnityMessage({
    topic: 'inference',
    message: {
      api: 'inference_request'
    }
  }, unity());
};

var processInferenceRequest = function processInferenceRequest(request) {
  var _request$message = request.message,
      uid = _request$message.uid,
      img = _request$message.img,
      name = _request$message.name,
      rotation = _request$message.rotation,
      dispose = _request$message.dispose;
  predict(img, uid).then(function (pred) {
    var payload = {
      uid: uid,
      img: img,
      name: name,
      rotation: rotation,
      confidences: pred.confidences,
      expectedY: dispose,
      predictedY: pred.dispose
    };
    store.dispatch(addInference(payload));
    sendPrediction(pred);
  }).catch(function (e) {
    console.log('rejected', e);
    resetGameLoop();
  });
};

var resetGameLoop = function resetGameLoop() {
  reloadAllExamples();
  sendPrediction({
    dispose: true,
    uid: "0000",
    color: {
      a: 1,
      b: 1,
      r: 1,
      g: 1
    }
  });
};

var showScore = function showScore(request) {
  var _store$getState = store.getState(),
      inferences = _store$getState.inferences;

  var score = batchScore(hiddenInferences(inferences));
  store.dispatch(addScore(score));
  store.dispatch(displayInferences());
  store.dispatch(setUnityConveyorWaitingForScore(false));
};

var isContinuous = function isContinuous(_) {
  sendUnityMessage({
    topic: 'inference',
    message: {
      api: 'continuous',
      param: {
        continuous_mode: store.getState().unityConveyorBelt.continuousMode
      }
    }
  }, unity());
};

var unityAwake = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_request) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            sendUnityMessageAsync({
              topic: 'game_settings',
              message: {
                api: 'load_scene',
                param: {
                  'game_settings': store.getState().game.game_settings
                }
              }
            }, unity(), "sim_awake_conveyor").then(function (_response) {
              store.dispatch(setUnityConveyorBeltAwake());
            });

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function unityAwake(_x) {
    return _ref.apply(this, arguments);
  };
}();

var sendPrediction = function sendPrediction(_ref2) {
  var dispose = _ref2.dispose,
      uid = _ref2.uid,
      rgb = _ref2.color.rgb;
  console.log("sending Prediction");
  sendUnityMessage({
    topic: 'inference',
    message: {
      api: 'prediction',
      param: {
        rgba: _objectSpread(_objectSpread({}, rgb), {}, {
          a: 255 * 0.4
        }),
        dispose: dispose,
        uid: uid
      }
    }
  }, unity());
};

var unity = function unity() {
  var _store$getState2 = store.getState(),
      unityConveyorBelt = _store$getState2.unityConveyorBelt;

  return unityConveyorBelt.content;
};

var events = {
  inference: processInferenceRequest,
  show_score: showScore,
  sim_awake_conveyor: unityAwake,
  is_continuous: isContinuous
};